import React, { useEffect, useState } from "react";
import DataTable from "../DRM/components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { setArchives } from "../../redux/actions/DRM_files.action";
import { setLoading } from "../../redux/actions/DRM_user.action";
import moment from "moment";
import FilterDialogue from "./FilterDialogue";
import { Box, Button, Tab, Typography } from "@mui/material";
import { GridToolbarQuickFilter, useGridApiRef } from "@mui/x-data-grid";
import { axios_tenant } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import WarningIcon from "@mui/icons-material/Warning";
import FlagIcon from "@mui/icons-material/Flag";
import { useCategory } from "./components/IpProvider";
import { TabContext, TabList } from "@mui/lab";
import { DateTimeStringFormatter } from "app/utils/date";
const CustomNoRowsOverlay = () => {
    const loading = useSelector((state) => state.userStore.loading);
    return (
        <div style={{ textAlign: "center" }}>
            <div className="m-3" style={{ fontSize: "15px" }}>
                {loading ? "Fetching Data..." : "No Records"}
            </div>
        </div>
    );
};
const Archive = (props) => {
	const dispatch = useDispatch();
	const apiRef = useGridApiRef();
	const { category, switchCategory } = useCategory()

	const archives = useSelector((state) => state.fileStore.archives);
	const loading = useSelector((state) => state.userStore.loading);

	const [selectedRows, setSelectedRows] = useState([]);
	const [filterDialogue, setFilterDialogue] = useState(false);

	const [tableData, setTableData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [isAllRowsSelected, setIsAllRowsSelected] = useState(false);

	const [filter, setFilter] = React.useState("");
	const [tenantMappings, setTenantMappings] = useState(null);


	function addSerialNumbers(data) {
		return data.map((item, index) => ({
			...item,
			serialnumber: index + 1,
		}));
	}

	const [customFilters, setCustomFilters] = React.useState({});

	useEffect(() => {
		if (apiRef.current?.setRowSelectionModel) {
			apiRef.current.setRowSelectionModel([]);
		  } else if (apiRef.current?.selectRows) {
			apiRef.current.selectRows([]);
		  }
		setSelectedRows([]);
		setIsAllRowsSelected(false);
		// reset to first page when switching tabs
		if (apiRef.current?.setPage) {
			apiRef.current.setPage(0);
		} else if (apiRef.current?.setPaginationModel) {
			apiRef.current.setPaginationModel((prev) => ({ ...prev, page: 0 }));
    }
		  
		getAuditResults();  // Fetch table data after reset
	}, [category]);

	const selectableRows = filteredData?.length > 0 ? filteredData : tableData;
	const totalSelectableRecords = selectableRows.length;

	useEffect(() => {
		const selectableIds = new Set(selectableRows.map((row) => row.id));

		if (isAllRowsSelected) {
			setSelectedRows(Array.from(selectableIds));
			return;
		}

		setSelectedRows((prevSelectedRows) =>
			prevSelectedRows.filter((id) => selectableIds.has(id))
		);
	}, [selectableRows, isAllRowsSelected]);
	

	const getAuditResults = async (customFilters) => {
		dispatch(setLoading(true));

		let reqParams = {
			limit: 100000,
			isArchived: 1,
		};

		if (customFilters) {
			reqParams = { ...reqParams, ...customFilters };
		}

		let response = await axios_tenant.get(`/drm/fetchAuditResult/v2?category=${category}`, { params: reqParams }).then((res) => res);

		if (response?.status == 200) {
			const tenantMapping = response.data?.data?.tenantMapping || {};
    
			setTenantMappings(tenantMapping || {});
			dispatch(setArchives(response.data.data.auditResults.filter((i) => i.is_archived == "1")));
			setTableData(addSerialNumbers(response.data.data.auditResults.filter((i) => i.is_archived == "1")));
		}

		if (filter) {
			filterTable(filter);
		}

		dispatch(setLoading(false));
	};

	const filterTable = (value) => {
		setFilter(value);

		if (value) {
			let filteredData = archives.filter((i) => {
				return String(i.application_number.toLowerCase()).includes(value.toLowerCase()) || String(i.docket_number.toLowerCase()).includes(value.toLowerCase()) || String(i.country.toLowerCase()).includes(value.toLowerCase()) || String(i.field_activity_name.toLowerCase()).includes(value.toLowerCase()) || String(i.issue_description.toLowerCase()).includes(value.toLowerCase()) || String(i.client_name.toLowerCase()).includes(value.toLowerCase());
			});

			setTableData(addSerialNumbers(filteredData));
		} else {
			setTableData(addSerialNumbers(archives));
		}
	};



	const columns = [
		{
            field: "serialnumber",
            headerName: tenantMappings?.serialnumber ||"S.N.",
            flex: 0.4
        },
        {
            field: "application_number",
            headerName:  tenantMappings?.application_number ||"Application No.",
            sortable: true,
            flex: 1.5
        },
        {
            field: "docket_number",
            headerName: tenantMappings?.docket_number ||"Matter ID",
            sortable: true,
            flex: 1.0
        },
        {
            field: "country",
            headerName: tenantMappings?.country || "Country",
            sortable: true,
            // width: 100,
            wrap: true,
            headerAlign: "center",
            align: "center"
        },
        {
            field: "audit_result",
            headerName: tenantMappings?.audit_result ||"Audit Result",
            headerAlign: "center",
            align: "center",
            renderCell(params) {
                return (<span>
                {params.row.audit_result === "ERROR" ? (<i className="text-danger"><WarningIcon/></i>) : (<i style={{color: "#FFBF00"}}><FlagIcon/></i>)}
                </span>);
            }
        },
        // {
        //     field: "field_activity_name",
        //     headerName: "Rule Name",
        //     flex: 1
        // },
        {
            field: "issue_description",
            headerName: tenantMappings?.issue_description ||"Issue Description",
            sortable: true,
            //   width: 200,
            wrap: true,
            flex: 1.75
		},
		{
			field: "client_name",
			headerName: tenantMappings?.client_name || "Client Name",
			headerClassName: 'no-active-border',
			sortable: true,
			flex: 1.8
		},
		{
            field: "foreign_associate",
            headerName: tenantMappings?.foreign_associate || "Foreign Associate",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1.3
        },
		{
            field: "status",
            headerName: tenantMappings?.status ||"Status",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1
        },
        {
            field: "matter_sub_matter_type",
            headerName: tenantMappings?.matter_sub_matter_type || "Filing Type",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1.3
        },
		{
			field: "batch_date",
			headerName: tenantMappings?.batch_date ||"Batch Date",
			headerClassName: 'no-active-border',
			sortable: true,
			flex: 1.3,
            valueFormatter: (params) =>
                DateTimeStringFormatter(params.value)
		},
		{
			field: "processed_by",
			headerName: tenantMappings?.processed_by ||"Processed By",
			headerClassName: 'no-active-border',
			// wrap: true,
			// noWrap: false,
		},
		{
		field: "custom_status_description",
		headerName: tenantMappings?.custom_status_description || "Custom Status",
		headerClassName: "no-active-border",
		sortable: true,
		flex: 1.5
		},
		{
		field: "priority_date",
		headerName: tenantMappings?.priority_date || "Priority Date",
		headerClassName: "no-active-border",
		sortable: true,
		flex: 1,
		valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD-MMM-YYYY") : ""
       },
	   {
		field: "action_taken",
			headerName: tenantMappings?.action_taken || "Action Taken",
			headerClassName: 'no-active-border',
			// wrap: true,
			// noWrap: false,
	   }
	];

	const applyCustomFilter = (data, type) => {
		let filterObj = {};

		if (type == "clear") {
			filterObj["startDate"] = "";
			filterObj["endDate"] = "";
			filterObj["clientName"] = "";
			filterObj["country"] = "";
			filterObj["fieldActivityName"] = "";
			setCustomFilters(filterObj);
			getAuditResults(filterObj);
			return;
		}

		setLoading(true);

		if (data.startDate) {
			filterObj["startDate"] = data.startDate;
		}

		if (data.endDate) {
			filterObj["endDate"] = data.endDate;
		}

		if (data.clientName) {
			filterObj["clientName"] = data.clientName;
		}

		if (data.country) {
			filterObj["country"] = data.country;
		}

		if (data.fieldActivityName) {
			filterObj["fieldActivityName"] = data.fieldActivityName;
		}

		getAuditResults(filterObj);


		setCustomFilters(filterObj);

		setLoading(false);
	};

	const deleteFromArchives = async () => {
		let arr = [...selectedRows];
		let response = await axios_tenant.post(`/drm/deleteFromArchives?category=${category}`, {
			ids: arr
		});
		if (response?.status == 200) {
			apiRef.current.setRowSelectionModel([]);
			setSelectedRows([]);
			setIsAllRowsSelected(false);
			await getAuditResults();
		}
	};

	const handleSelectAllRecords = () => {
		setSelectedRows(selectableRows.map((row) => row.id));
		setIsAllRowsSelected(true);
	};

	const handleClearSelection = () => {
		setSelectedRows([]);
		setIsAllRowsSelected(false);
		apiRef.current?.setRowSelectionModel?.([]);
	};
const csvData = React.useMemo(() => {
    if (selectedRows.length > 0) {
        return tableData.filter((row) => selectedRows.includes(row.id));
    }

    if (filteredData?.length > 0) {
        return filteredData;
    }

    return [];
}, [selectedRows, tableData, filteredData]);

const customToolbar = React.useCallback(() => {
		return (
			<Box sx={{
				display: 'flex',
				justifyContent: 'flex-end', gap: 2,
				alignItems: 'center'
			}}>
				<Button
					startIcon={<DeleteIcon />}
					size="small"
					onClick={() => deleteFromArchives()}
				>
					Delete
				</Button>
			<CSVLink
	data={
		csvData
	.map((row) => {
      let newRow = {};
      columns.forEach((column) => {  
	  
        newRow[column.headerName] =
          typeof row[column.field] === "number"
            ? row[column.field].toString()
            : row[column.field];
      });
        const localDate = new Date(row.batch_date);

        newRow["Batch Date"] = [
            String(localDate.getDate()).padStart(2, "0"),
            String(localDate.getMonth() + 1).padStart(2, "0"),
            localDate.getFullYear(),
            ].join("/");
      newRow["Batch Time"] = new Date(row.batch_date).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
	  newRow['Priority Date'] = row.priority_date || '';
      return newRow;
    })
  }
  filename={category + "_archived_audit_results.csv"}
>
  <Button
    startIcon={<FileDownloadIcon />}
    size="small"
  >
    Export As CSV
  </Button>
</CSVLink>


				   <GridToolbarQuickFilter debounceMs={300} />
			</Box>
		)
}, [selectedRows, filteredData, tableData, tenantMappings, category]);

	const selectionToolbar = React.useCallback(() => {
		if (!selectedRows.length) {
			return null;
		}

		if (isAllRowsSelected) {
			return (
				<Typography variant="body2" sx={{ fontWeight: 500 }}>
					All {totalSelectableRecords} records selected.{" "}
					<Button
						size="small"
						variant="text"
						onClick={handleClearSelection}
						sx={{ minWidth: "auto", padding: 0, textTransform: "none", verticalAlign: "baseline" }}
					>
						Clear Selection
					</Button>
				</Typography>
			);
		}

		return (
			<Typography variant="body2" sx={{ fontWeight: 500 }}>
				{selectedRows.length} records selected.{" "}
				<Button
					size="small"
					variant="text"
					onClick={handleSelectAllRecords}
					sx={{ minWidth: "auto", padding: 0, textTransform: "none", verticalAlign: "baseline" }}
				>
					Click Here
				</Button>{" "}
				to select all {totalSelectableRecords} records.
			</Typography>
		);
	}, [selectedRows, isAllRowsSelected, totalSelectableRecords]);

	const handleTabChange = (event, newValue) => {
		switchCategory(newValue);
	};
	let content;
	if (tenantMappings === null) {
		content = <div>Loading...</div>;
	} else if (!tableData?.length && !loading) {
		content = <CustomNoRowsOverlay />;
	} else {
		content = (
			<DataTable
				columns={columns}
				data={tableData}
				checkboxSelection
				showToolbar={true}
				apiRef={apiRef}
				loading={loading}
				setLoading={setLoading}
				customToolbar={customToolbar}
				toolbarLeftComponent={selectionToolbar}
				noRowsOverlay={CustomNoRowsOverlay}
				rowSelectionModel={selectedRows}
				onRowSelectionModelChange={(newSelection) => {
					setSelectedRows(newSelection);
					setIsAllRowsSelected(
						newSelection.length > 0 &&
						newSelection.length === totalSelectableRecords
					);
				}}
				onFilteredDataChange={setFilteredData}
				initialState={{
					columns: {
						columnVisibilityModel:
							tenantMappings?.columnVisibilityModel || {
								client_name: false,
							},
					},
				}}
				selectableRows={true}
				getRowHeight={() => "auto"}
				sx={{
					"& .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-cellContent": {
						whiteSpace: "normal",
						overflow: "hidden",
						textOverflow: "ellipsis",
					},
					"& .MuiDataGrid-columnHeaderTitle": {
						lineHeight: 1.5,
					},
					"& .MuiDataGrid-columnHeaders": {
						position: "sticky",
						top: 80,
						zIndex: 1000,
						backgroundColor: "#fff",
					},
					"& .MuiDataGrid-main": {
						overflow: "unset",
					},
				}}
			/>
		);
	}

	return (
		<>
			<div>
				<Box sx={{
					marginBottom: "20px"
				}}>
					<TabContext value={category}>
						<TabList onChange={handleTabChange} aria-label="lab API tabs example">
							<Tab label={`Patent`} value="patent" />
							<Tab label={`Trademark`} value="trademark" />
						</TabList>
					</TabContext>
				</Box>
				<Box mb={2} style={{ display: 'flex', alignItems: 'baseline' }}>
					<Typography variant="h2" component="h2">
						Archives
					</Typography>
					<Typography variant="body1">
						&nbsp;({archives.length} {archives.length == 1 ? "Record" : "Records"})
					</Typography>
				</Box>

				<div className="mt-3">
				{content}
				</div>
			</div>

			{filterDialogue ? <FilterDialogue toggleDialogue={() => setFilterDialogue(!filterDialogue)} applyCustomFilter={(data) => applyCustomFilter(data)} customFilters={customFilters} /> : null}
		</>
	);
};

export default Archive;
